import moment from "moment";
import React from "react";
import { Message } from "components/Atoms/Message";
import SearchFlight from "./SearchFlight";
import { Loader } from "semantic-ui-react";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";
import { FlightSearchResult } from "./FlightSearchResult";
import { FlightAIAd } from "./FlightAIAd";

interface Props {
  artist: server.dto.ArtistSmall | null;
  airline: server.dto.Airline
  departureDate: moment.Moment

  onAirlineChange: (airline: server.dto.Airline) => void
  onDepartureDateChange: (date: moment.Moment) => void

  onSelect: (flight: server.dto.ScheduledFlightFromFlightStats) => void
}

export const FlightLookup = (props: Props) => {
  const [flightNumber, setFlightNumber] = React.useState(null);
  const [airlineLeftEmptyError, setAirlineLeftEmptyError] = React.useState(false);
  const [flightNumberLeftEmptyError, setFlightNumberLeftEmptyError] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState<server.dto.ScheduledFlightFromFlightStats[]>(null);

  const onFlightSearch = async (nr: number) => {
    const airlineEmpty = props.airline === null;
    const flightNumberEmpty = nr === 0;

    if (airlineEmpty || flightNumberEmpty) {
      setAirlineLeftEmptyError(airlineEmpty);
      setFlightNumberLeftEmptyError(flightNumberEmpty);
      return;
    }
    setError(null);
    setIsLoading(true);

    const result = await window.CoreApi.Flight.RetrieveFlightFromFlightStats({
      airlineId: props.airline.airlineId,
      flightNumber: nr,
      departure: props.departureDate.toDate()
    });

    setIsLoading(false);
    if (result.data.hasErrors) {
      setError(result.data.errors[0].message);
      return;
    }

    setData(result.data.data);
  }

  return <>
    <div className="flex-column gap">
      <SearchFlight
        onSearch={onFlightSearch}
        airlineHasError={airlineLeftEmptyError}
        flightNumberHasError={flightNumberLeftEmptyError}
        airline={props.airline}
        flightNumber={flightNumber}
        departureDate={props.departureDate}
        onAirlineChange={a => {
          props.onAirlineChange(a);
          setAirlineLeftEmptyError(false);
        }}
        onFlightNumberChange={nr => {
          setFlightNumber(nr);
          setFlightNumberLeftEmptyError(false);
        }}
        onDepartureDateChange={props.onDepartureDateChange}
      />
      {isLoading && <Loader active inline="centered" />}
      {!isLoading && <>
        {error && <Message type="error">{error}</Message>}
        {data !== null && data.length === 0 && <NoDataAvailableDiv />}
        {data !== null && data.length > 0 && <div className="flex-column gap-tiny">
          {data.map((d) => <FlightSearchResult
            key={d.flightDesignator}
            data={d}
            onSelect={selectedFlight => props.onSelect(selectedFlight)}
          />)}
        </div>}
      </>}

      <FlightAIAd artist={props.artist} />
    </div>
  </>
}